export default __webpack_public_path__ + "static/media/Thong-bao_Benh-vien-lao-phoi-TV-_Thue-MB.2787a31e.pdf";